import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BackgroundIllustrations from '../components/common/BackgroundIllustrations';
import SurveyService from '../services/survey.service';
import TimePreferenceService from '../services/time-preference.service';
import Logo from '../components/common/Logo';
import SurveyStep from '../components/patient/SurveyStep';
import TimePreferenceStep from '../components/patient/TimePreferenceStep';
import AuthService from '../services/auth.service';


const PatientSurvey = () => {
  const [questions, setQuestions] = useState([]);
  const [currentStep, setCurrentStep] = useState(0);
  const [responses, setResponses] = useState({});
  const [showTimePreference, setShowTimePreference] = useState(false);
  const [timePreferences, setTimePreferences] = useState({
    morning: false,
    afternoon: false,
    evening: false,
    flexible: false
  });
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    loadQuestions();
  }, []);

  const loadQuestions = async () => {
    try {

      const user = AuthService.getUserFromStorage();
      const userTagId = user?.tag_id || 8;
      console.log('[DEBUG] Loading survey questions for tag ID:', user);
      console.log('[DEUBG] Loading survey questions for tag ID:', userTagId);
      const data = await SurveyService.getQuestions(userTagId);

      setQuestions(data);
    } catch (error) {
      console.error('[DEBUG] Survey - Error loading questions:', error);
    }
  };

  const handleStepSubmit = async (response) => {
    const updatedResponses = { 
      ...responses, 
      [questions[currentStep].id]: response 
    };
    setResponses(updatedResponses);
    
    if (currentStep === questions.length - 1) {
      // Se è l'ultima domanda del questionario, mostra la schermata delle preferenze orarie
      setShowTimePreference(true);
    } else {
      setCurrentStep(currentStep + 1);
    }
  };
  
  const handleTimePreferenceSubmit = async (preferences) => {
    setTimePreferences(preferences);
    setSubmitting(true);
    
    try {
      // Prima invia le risposte del questionario
      await SurveyService.submitSurvey(formatResponses(responses));
      
      // Poi invia le preferenze orarie
      await TimePreferenceService.updatePreference(preferences);
      
      // Reindirizza alla dashboard
      navigate('/patient/dashboard');
    } catch (error) {
      console.error('[DEBUG] Survey - Error submitting:', error);
    } finally {
      setSubmitting(false);
    }
  };

  const handleBack = () => {
    if (showTimePreference) {
      setShowTimePreference(false);
    } else if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const formatResponses = (data) => {
    return Object.entries(data).map(([questionId, response]) => {
      const question = questions.find(q => q.id === parseInt(questionId));
      
      return {
        question_id: parseInt(questionId),
        text_answer: response.text_answer || null,
        selected_option_ids: question.type !== 'text' ? response.selected_option_ids : []
      };
    });
  };

  if (!questions.length) return null;

  return (
    <div className="relative min-h-screen flex flex-col w-full">
      <BackgroundIllustrations className="absolute inset-0 z-0" />
      <div className="flex-grow flex flex-col items-center justify-between relative z-10 w-full">
        <div className="w-full mt-8 px-4">
          <Logo className="mb-8" />
          <div className="bg-white p-8 rounded-lg shadow-md mx-auto max-w-2xl w-full">
            {!showTimePreference ? (
              <SurveyStep
                question={questions[currentStep]}
                onSubmit={handleStepSubmit}
                currentStep={currentStep}
                totalSteps={questions.length + 1} // +1 per includere lo step delle preferenze orarie
                onBack={handleBack}
              />
            ) : (
              <TimePreferenceStep
                preferences={timePreferences}
                onSubmit={handleTimePreferenceSubmit}
                onBack={handleBack}
                submitting={submitting}
                currentStep={questions.length}
                totalSteps={questions.length + 1}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientSurvey;